module.exports = __webpack_public_path__ + "img/oth1.e0ae60c0.png";